import { FETCH_MANIFESTS } from "../actions/types";

var date = new Date();
var year = date.getFullYear();

const initialState = {
    results: [],
    facility: [],
    searchResults: [],
    keyword: "",
    isFetching: false,
    options: {
        page: 1,
        pageSize: 10,
        total_records: 0
    },
    filters: {
        epa_id: "",
        manifestId: "",
        shipYear: "",
        facility: false,
        street: "",
        city: "",
        active: "both",
        county: "",
        zipCode: "",
        sort: "EPA_ID",
        sortBy: "ASC",
        manifestType: "all",
        type: "all",
        page: 1,
        pageSize: 10
    }
};

export default function (state = initialState, actions) {
    switch (actions.type) {
        case FETCH_MANIFESTS:
            return {
                ...state,
                searchResults: actions.payload,
                isFetching: actions.isFetching,
                options: actions.options,
                keyword: actions.keyword
            };
        default:
            return state;
    }
}